// import UserDetailHeader from "../../components/user-detail/UserDetailHeader";
// <UserDetailHeader typeSelectBox={true} addNewIncident={true} />
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../components/general/ProgressComponent";
import Layout from "../../components/layouts/Layout";
import editBlock from "../../assets/images/icons/editBlock.svg";
import eventDel from "../../assets/images/icons/eventDel.svg";
// import AddPbsPlans from "./AddPbsPlans";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactHtmlParser from 'html-react-parser';
import { ToastContainer, toast } from "react-toastify";
import password_eye_icon_circle from "../../assets/images/icons/password_eye_icon_circle.svg";
import { hasAnyPermissions } from "../../permission_advance/PermissionColumn";
import "react-toastify/dist/ReactToastify.css";
import {
  BASE_URL,
  GET_RECENT_INCIDENT_URL,
  DELETE_RECENT_INCIDENT_URL,
} from "../../env";
import {
  getRecords,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
  deleteRecords,
  catchAsync,
} from "../../helper/helper";
import ProtectedComponent from '../../permissions/ProtectedComponent';
import { permissions } from '../../permissions/roles';
// import EditPbsPlans from "./EditPbsPlans";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
function RecentIncidents() {
  if (localStorage.getItem('recentIncidentDetail')) {
    localStorage.removeItem('recentIncidentDetail');
  }
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  const [userData, setUserData] = useState([]);
  const apiQuery = {
    query: {
      critarion: {
        userId: userDetails?._id,
      }
    },
    sortProperty: "incidentDate",
    sortOrder: -1
  };
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filterSearch, setFilterSearch] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [pbsIdData, setPbsPlansIdData] = useState({
    id: null,
  });
  const [pbsPlansDetail, setPbsPlansDetail] = useState();
  const [isPbsPlans, setIsPbsPlans] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

  // Modal Popup
  // const [showAddPbsPlans, setShowAddPbsPlans] = useState(false);
  // const subModalAddPbsPlans = () => {
  //   setShowAddPbsPlans(!showAddPbsPlans);
  //   fetchAllRecords();
  // };

  const [showDeletePbsPlans, setShowDeletePbsPlans] = useState(false);
  const subModalDeletePbsPlans = (pbsItemId) => {
    setPbsPlansIdData({ id: pbsItemId });
    setShowDeletePbsPlans(!showDeletePbsPlans);
    fetchAllRecords();
  };

  // const [showEditPbsPlans, setShowEditPbsPlans] = useState(false);
  // const subModalEditPbsPlans = (pbsItem) => {
  //   setPbsPlansDetail(pbsItem);
  //   setShowEditPbsPlans(!showEditPbsPlans);
  //   fetchAllRecords();
  // };

  // Getting records from DB
  const processFetchRecords = (method, data) => {
    if (method === "get" && data?.status === isSuccess) {
      const actionRecentIncidentsData = data?.data?.filter((item) => item?.active === true)
      const recentIncidentsData = actionRecentIncidentsData?.map((item) => item);
      setUserData(recentIncidentsData);
      setFilterSearch(recentIncidentsData);
      setIsLoading(false);
      // toastSuccessMessages(toast.success, data?.message, "", 500, 500);
    } else if (method === "delete" && data?.status === isSuccess) {
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setTimeout(() => {
        setIsPbsPlans(false);
      }, 2000);
    }
    // else {
    //   console.log({ data });
    //   toastErrorMessages(toast.error, data?.message, 1000);
    // }
  };

  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_RECENT_INCIDENT_URL, apiQuery);
    
    processFetchRecords("get", response);
  });

  useEffect(() => {
    fetchAllRecords();
  }, []);

  // Table Columns

  const columns = [
    {
      name: "Recent Date and Time",
      selector: (row) => {
        return (
          <div>
            <p className="m-0">{moment(row?.incidentDate).format("DD/MM/YYYY / hh:mm:ss A")}</p>
          </div>
        );
      },
      width: "20%",
    },
    {
      name: "Title",
      selector: (row) => {
        return (
          <div>
            <p className="m-0">{row?.incidentTitle}</p>
          </div>
        );
      },
      width: "70%",
    },
    ...(hasAnyPermissions(["create", "update", "delete"], "PBS Review")
      ? [
        {
          name: "Action",
          selector: (row) => {
            return (
              <div className="actionColumns individualReviewsActions">

                <span className="edit" onClick={() => handleEditViewPBSPlans(row, "/view-incidents")}>
                  <img src={password_eye_icon_circle} alt="View" title="View" />
                </span>
                <PermissionWrapper title="Recent Incidents" action="create">
                  <span className="edit" onClick={() => handleEditViewPBSPlans(row, "/edit-incidents")}>
                    <img src={editBlock} alt="Edit" title="Edit" />
                  </span>
                </PermissionWrapper>
                <PermissionWrapper title="Recent Incidents" action="delete">
                  <span
                    className="delete"
                    onClick={() => {
                      subModalDeletePbsPlans(row?._id);
                    }}
                  >
                    <img src={eventDel} alt="Delete" title="Delete" />
                  </span>
                </PermissionWrapper>
              </div>
            );
          },
          width: "10%",
          center: true,
          wrap: true,
        },
      ]
      : []),
  ];

  // Search Filter
  useEffect(() => {
    const result = userData.filter((user) => {
      const incidentDateTime = moment(user?.incidentDate).format("DD/MM/YYYY / hh:mm:ss A")
      return incidentDateTime.toLowerCase().match(search.toLowerCase());
    });
    setFilterSearch(result);
  }, [search, userData]);

  // Delete record
  const deleteRecord = catchAsync(async (req, res) => {
    setIsSubmitButtonClicked(true);
    if (pbsIdData !== "") {
      const response = await deleteRecords(
        DELETE_RECENT_INCIDENT_URL,
        pbsIdData
      );

      setIsPbsPlans(true);
      processFetchRecords("delete", response);
      fetchAllRecords();
      setIsSubmitButtonClicked(false);
      setShowDeletePbsPlans(!showDeletePbsPlans);
    } else {
      setShowDeletePbsPlans(!showDeletePbsPlans);
      setIsSubmitButtonClicked(false);
      setIsPbsPlans(true);
      toastErrorMessages(toast.error, "Unable to remove", "", 1000);
    }
  });
  useEffect(() => {
    setTimeout(() => {
      setIsPbsPlans(false);
    }, 2000);
  }, [isPbsPlans])

  const handleEditViewPBSPlans = (item, url) => {
    localStorage.setItem(
      "recentIncidentDetail",
      JSON.stringify(item)
    );
    navigate(url);
  };

  return (
    <>
      <Layout pageTitleText="Recent Incidents">
        <div className="rowClickUnset pbsPlanUpdated">
          <div className="mainContent">

            <div className="dataTableWrapper">
              <DataTable
                className="maxWidthTable minWidthTable"
                columns={columns}
                data={filterSearch}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                paginationPerPage={10}
                fixedHeader
                fixedHeaderScrollHeight="520px"
                highlightOnHover
                actions={
                  <>
                    <PermissionWrapper title="Recent Incidents" action="create">
                      <Link to="/add-incidents" className="btn btn-sm btn-primary">
                        Add New Incident
                      </Link>
                    </PermissionWrapper>
                  </>
                }
                responsive={true}
                subHeader={true}
                subHeaderComponent={
                  <div className="searchContainer">
                    <div className="searchTextBox">
                      <input
                        type="text"
                        placeholder="Search by Date"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>
                }
                subHeaderAlign="left"
                subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                progressPending={isLoading}
                progressComponent={<ProgressComponent />}
              />
            </div>
          </div>
        </div>
      </Layout>


      {/* Delete PBS Plans */}

      <Modal
        show={showDeletePbsPlans}
        onHide={subModalDeletePbsPlans}
        className="ftcModalPopup confirmationPopup deletionConfirmation"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="editBlockContent text-center">
            <img src={eventDel} alt={eventDel} />
            <p>Are you sure you want to delete this item?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {isSubmitButtonClicked ? (
            <Button className="btn-sm" variant="danger" disabled>
              Loading...
            </Button>
          ) : (
            <Button className="btn-sm" variant="danger" onClick={deleteRecord}>
              Yes
            </Button>
          )}

          <Button
            className="btn-sm"
            variant="outline-secondary"
            onClick={subModalDeletePbsPlans}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

      {isPbsPlans && <ToastContainer />}
    </>
  );
}

export default RecentIncidents;
